module.exports = __webpack_public_path__ + "assets/img/crayon3.9879a708.png";